import { ManagementPrivate } from "@busy-human/k9-library";
import { onSnapshot } from "firebase/firestore";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useAuth } from "./auth";

export const usePrivate = defineStore('private', () => {

    const data = ref<ManagementPrivate.Model | null>(null);

    const auth = useAuth();
    const unsub = ref<(() => void) | null>(null);

    watch(() => auth.currentUid, async uid => {
        if(unsub.value !== null) unsub.value();
        if(uid) {
            const docref = ManagementPrivate.Collection.docRef(uid);
            unsub.value = onSnapshot(docref, snap => {
                const d = snap.data() as ManagementPrivate.Model | undefined;
                if(d) {
                    data.value = d;
                } else {
                    data.value = null;
                }
            });
        }
    }, { immediate: true });

    const isValid = computed(() => data.value && data.value.refreshToken);

    return { data, isValid };
});